import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import './styles.scss';
import SwitchButton from '../SwitchButton';
import Arrow from '../Arrow';
import { ALWAYS_ACTIVE } from '../Modal/CookiesAcceptationModal';

const BoxWithCollapse = ({ active, title, children, onFunctionalActiveChange, preferencesConfirmed }) => {
  const [isOpen, setOpen] = useState(false);
  const [directionDown, setDirectionDown] = useState(false);

  const { t } = useTranslation('account');

  const toggle = () => {
    setOpen(!isOpen);
    setDirectionDown(!directionDown);
  };

  return (
    <>
      <div className="collapse-box">
        <div onClick={toggle} className="align-items-center title-div">
          <Arrow directionDown={directionDown} />
          <div>
            <span className="title-cookie">{title}</span>
          </div>
        </div>
        <div className="buttons">
          {active === ALWAYS_ACTIVE ? (
            <span className="indicator-small-text">{t('cookieModals.alwaysActive')}</span>
          ) : (
            <SwitchButton
              t={t}
              preferencesConfirmed={preferencesConfirmed}
              onActivateChange={onFunctionalActiveChange}
            />
          )}
        </div>
      </div>
      {(children || active === ALWAYS_ACTIVE) && <Collapse isOpen={isOpen}>{children}</Collapse>}
    </>
  );
};

export default BoxWithCollapse;
